import { render } from "./Top1Slide.vue?vue&type=template&id=40a0b2e4&scoped=true"
import script from "./Top1Slide.vue?vue&type=script&lang=js"
export * from "./Top1Slide.vue?vue&type=script&lang=js"

import "./Top1Slide.vue?vue&type=style&index=0&id=40a0b2e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a0b2e4"]])

export default __exports__